// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__dMu8q","content":"LoadingAlert_content__1_x7e"};